// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { threeCirclesAscendingContainer16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-three-circles-ascending-container': IconThreeCirclesAscendingContainer;
    }
}

/**
 * The icon component for the 'threeCirclesAscendingContainer' icon
 */
export class IconThreeCirclesAscendingContainer extends IconSvg {
    public constructor() {
        super(threeCirclesAscendingContainer16X16);
    }
}

registerIconSvg('icon-three-circles-ascending-container', IconThreeCirclesAscendingContainer);
export const iconThreeCirclesAscendingContainerTag = 'nimble-icon-three-circles-ascending-container';
